import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withKeys as _withKeys, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3fa889c8")

_pushScopeId("data-v-3fa889c8")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-cancel" })
], -1)
const _hoisted_2 = { class: "dialog__content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: "/images/home/logo_main.png"
}, null, -1)
const _hoisted_4 = { class: "dialog__list" }
const _hoisted_5 = { class: "dialog__item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-user-o" }, null, -1)
const _hoisted_7 = { class: "dialog__item" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-lock" }, null, -1)
const _hoisted_9 = { class: "dialog__item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-lock" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "dialog__item" }, [
  /*#__PURE__*/_createVNode("span", { class: "dialog_subitem" }, "Informations additionnelles")
], -1)
const _hoisted_13 = { class: "dialog__item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon-info-circled" }, null, -1)
const _hoisted_15 = { class: "dialog__item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-crown" }),
  /*#__PURE__*/_createTextVNode("Capitaine")
], -1)
const _hoisted_17 = { class: "dialog__item item--teams" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "icon-team" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Équipe: ")
const _hoisted_20 = { class: "perm_signupTeams--noedit" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "icon-cancel" }, null, -1)
const _hoisted_22 = { class: "dialog__notes" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "icon-attention" }, null, -1)
const _hoisted_24 = { class: "footer__buttons" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "icon-user-add" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" S'incrire ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.signupDialogVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: false,
            tabindex: "0",
            onClose: _ctx.closeDialog,
            onKeyup: _withKeys(_ctx.fetchAccount, ["enter"]),
            onKeydown: _withKeys(_ctx.closeDialog, ["esc"])
          }, {
            body: _withId(() => [
              _createVNode("div", {
                class: "button button--minimal close__button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
              }, [
                _hoisted_1
              ]),
              _createVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      placeholder: "Courriel",
                      tabindex: "0",
                      ref: "username",
                      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.formIncomplete && _ctx.formIncomplete(...args))),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.signupUsername = $event))
                    }, null, 544), [
                      [_vModelText, _ctx.signupUsername]
                    ])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createVNode("input", {
                      type: "password",
                      ref: "password",
                      tabindex: "0",
                      placeholder: "Mot de passe",
                      onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.formIncomplete && _ctx.formIncomplete(...args))),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.password = $event))
                    }, null, 544), [
                      [_vModelText, _ctx.password]
                    ])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createVNode("input", {
                      type: "password",
                      ref: "passwordConfirm",
                      tabindex: "0",
                      placeholder: "Confimation du mot de passe",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.passwordConfirm = $event)),
                      onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkPasswordMatch && _ctx.checkPasswordMatch(...args))),
                      onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.passwordConfirm = ''))
                    }, null, 544), [
                      [_vModelText, _ctx.passwordConfirm]
                    ])
                  ]),
                  _hoisted_11,
                  _hoisted_12,
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      placeholder: "Nom",
                      tabindex: "0",
                      ref: "name",
                      onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.formIncomplete && _ctx.formIncomplete(...args))),
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.signupName = $event))
                    }, null, 544), [
                      [_vModelText, _ctx.signupName]
                    ])
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_Checkbox, {
                      value: "Team Captain",
                      checked: _ctx.isTeamCaptain,
                      onToggle: _ctx.setTeamCaptain
                    }, null, 8, ["checked", "onToggle"])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("span", null, [
                      _hoisted_18,
                      _hoisted_19,
                      _createVNode("div", _hoisted_20, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teams, (team, ix) => {
                          return (_openBlock(), _createBlock("div", {
                            key: ix,
                            class: "team-name",
                            onClick: ($event: any) => (_ctx.removeTeam(team))
                          }, [
                            _createVNode(_component_TeamLabel, {
                              team: _ctx.teamInfo(team)
                            }, null, 8, ["team"]),
                            _hoisted_21
                          ], 8, ["onClick"]))
                        }), 128))
                      ])
                    ]),
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.signupTeams[_ctx.teams.length] = $event))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableTeams, (team, ix) => {
                        return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.signupTeams[_ctx.teams.length]]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", {
                    class: "notes notes--error",
                    style: {
                                'visibility': _ctx.signupError || _ctx.formError? 'visible': 'hidden'
                            }
                  }, [
                    _hoisted_23,
                    _createVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
                  ], 4)
                ])
              ])
            ]),
            footer: _withId(() => [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", {
                  class: "button button--action button--grow",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.fetchAccount && _ctx.fetchAccount(...args)))
                }, [
                  _createVNode("span", null, [
                    _hoisted_25,
                    _hoisted_26,
                    _createVNode("i", {
                      class: {
                                    'icon-right-open': _ctx.signupReady,
                                    'icon-spinner animate-spin': _ctx.signupLoading
                                }
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onKeyup", "onKeydown"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})